import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const currentLang = localStorage.getItem("zoz_dash_Lang") || "ar";

export default new Vuetify({
  rtl: currentLang === "ar",
  theme: {
    themes: {
      light: {
        primary: "#783D73",
      },
    },
  },
});
